import { useEffect, useState } from "react";
import { useTable } from "src/hooks/useTable";
import { useDebounce } from "src/hooks/useDebounce";
import { getForceUpdateUseCase } from "../useCases/getForceUpdateUseCase";

export const useForceUpdateTable = () => {
    const [loading, setLoading] = useState(false);
    const { rowsPerPage, page, search, onSearch, onChangePage, onChangeRowsPerPage } = useTable();

    useEffect(() => {
        onGetList();
    }, [rowsPerPage, page])

    useEffect(() => {
        debouncedWrapper();
    }, [search])

    const onGetList = async () => {
        if (!loading) {
            setLoading(true);
            await getForceUpdateUseCase();
            setLoading(false);
        }
    };

    const { debouncedWrapper } = useDebounce(onGetList, 500)

    return { rowsPerPage, page, search, onSearch, onChangePage, onChangeRowsPerPage };
};